import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        estado: {
            display: 'flex',
            alignItems: 'center',
        },
        indicador: {
            display: 'flex',
            borderRadius: '50%',
            width: '0.625rem',
            height: '0.625rem',
            marginRight: '0.375rem',
        },
        indicadorOk: {
            backgroundColor: 'var(--verde-exito)',
        },
        indicadorWarning: {
            backgroundColor: 'var(--amarillo-advertencia)',
        },
        indicadorError: {
            backgroundColor: 'var(--rojo-error)',
        },
    });
});
export default useStyles;
